<script>
    import {notifications} from "../notifications";
    import {onMount} from "svelte";
    import {resourcesUrl} from "../urls";
    import StraightTable from "../components/StraightTable.svelte";
    import {
        dateView,
        editableImageView,
        labelView,
        valueView, saveRows
    } from "../tableUtils";

    onMount(init)

    import {
        error as resourcesFetchingError,
        load as loadResources,
        resources,
    } from "../stores/resourceStore";

    $: $resourcesFetchingError && notifications.danger($resourcesFetchingError)

    function init() {
        loadResources()
    }

    async function save(e) {
        const rows = e.detail.data;
        let fields = columns.map(elem => elem.field);
        await saveRows(rows, fields, resourcesUrl());
        await loadResources();
    }

    let columns = [
        {title: 'ID', field: 'ID', sortable: true, defaultValue: null, editView: labelView},
        {title: 'Image', field: 'NewIcon', sortable: false, defaultValue: null, editView: editableImageView()},
        {title: 'Name', field: 'Name', sortable: false, defaultValue: "", editView: valueView("text")},
        {title: 'Price', field: 'Price', sortable: true, defaultValue: 0, editView: valueView("number", 1000, 0)},
        {title: 'Updated At', field: 'UpdatedAt', sortable: true, defaultValue: new Date(), editView: dateView},
    ];
</script>

<StraightTable data={$resources} {columns} on:change={save}/>
